import { Menu, Portal } from '@chakra-ui/react';

/**
 * @param {{
 *   trigger?: import('react').ReactNode,
 *   items: import('react').ReactNode,
 *   children?: import('react').ReactNode,
 *   [menuRootProp: string]: unknown,
 * }} props
 */
const VMenu = ({ trigger, items, children, ...props }) => {
  return (
    <Menu.Root {...props}>
      {children || (trigger && <Menu.Trigger asChild>{trigger}</Menu.Trigger>)}
      <Portal>
        <Menu.Positioner>
          <Menu.Content>{items}</Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};

export default VMenu;
